export const SET_PHOTO_EDITOR_MATERIAL = 'SET_PHOTO_EDITOR_MATERIAL'
export const CLOSE_PHOTO_EDITOR_MATERIAL = 'CLOSE_PHOTO_EDITOR_MATERIAL'

export const OPERATION_STARTED = 'OPERATION_STARTED'
export const OPERATION_FAILED = 'OPERATION_FAILED'

export const GET_MATERIALS_SUCCESS = 'GET_MATERIALS_SUCCESS'

export const GET_ROOMS_SUCCESS = 'GET_ROOMS_SUCCESS'

export const GET_MATERIAL_BY_ID = 'GET_MATERIAL_BY_ID'

export const UPLOAD_MATERIAL_SUCCESS = 'UPLOAD_MATERIAL_SUCCESS'
export const RESET_MATERIAL_SUCCESS = 'RESET_MATERIAL_SUCCESS'

export const DELETE_MATERIAL_SUCCESS = 'DELETE_MATERIAL_SUCCESS'
export const DELETE_ROOM_SUCCESS = 'DELETE_ROOM_SUCCESS'

export const UPLOAD_ROOM_SUCCESS = 'UPLOAD_ROOM_SUCCESS'

export const EDIT_MATERIAL_TITLE_SUCCESS = 'EDIT_MATERIAL_TITLE_SUCCESS'
export const EDIT_ROOM_TITLE_SUCCESS = 'EDIT_ROOM_TITLE_SUCCESS'

export const ACTIVE_PATH = 'ACTIVE_PATH'
export const CHOOOSE_ROOM = 'CHOOOSE_ROOM'
export const CHOOSE_ROOM_INITIAL = 'CHOOSE_ROOM_INITIAL'
export const SELECT_CURVE = 'SELECT_CURVE'
export const RESET_DRAG = 'RESET_DRAG'
export const APPLY_CURVE_FILTER = 'APPLY_CURVE_FILTER'
export const APPLY_TEXTURE_ZOOM = 'APPLY_TEXTURE_ZOOM'
export const CHANGE_CURVE_MULTIPLY = 'CHANGE_CURVE_MULTIPLY'
export const CHANGE_MULTIPLY = 'CHANGE_MULTIPLY'

export const GET_ROOM_SUCCESS = 'GET_ROOM_SUCCESS'

export const DRAWING_STARTED = 'DRAWING_STARTED'
export const DRAWING_ENDED = 'DRAWING_ENDED'

export const SAVE_GRAY_SCALE_IMAGES = 'SAVE_GRAY_SCALE_IMAGES'
